import React, {useState} from 'react';
import './style.scss';
import {Button, Card, Col, Layout, Modal, Row, Table, Tag, Tooltip} from "antd";
import {Content} from "antd/es/layout/layout";
import ProPortalHeader from "../../componets/ProPortalHeader";
import ProfileRow from "../../componets/ProfileRow";
import Navigator from "../../componets/Navigator";
import {ReactComponent as TickCircle} from "./imgs/Tick Circle.svg";
import {ReactComponent as CrossCircle} from "./imgs/Cross Circle.svg";
import {ReactComponent as InfoButton} from "./imgs/Info button.svg";
import {useNavigate} from "react-router-dom";


const MyAccount = () => {
    const [activeTab, setActiveTab] = useState('subscription');

    return (
        <Layout>
            <Content>
                <ProPortalHeader/>
                <ProfileRow/>
                <Row justify={"center"}>
                    <Layout>
                        <Navigator/>
                        <Layout>
                            <Col lg={24} style={{
                                background: '#F4F4F4',
                            }}>
                                <div className="ma-tabs-container">
                                    <Button
                                        className={`${activeTab === 'subscription' ? 'ma-active-tab' : 'ma-inactive-tab'}`}
                                        onClick={() => setActiveTab('subscription')}
                                    >
                                        Subscription
                                    </Button>
                                    <Button
                                        className={`${activeTab === 'additional' ? 'ma-active-tab' : 'ma-inactive-tab'}`}
                                        onClick={() => setActiveTab('additional')}
                                    >
                                        Additional Services
                                    </Button>
                                </div>
                                {activeTab === 'additional' && <AdditionalServices/>}
                                {activeTab === 'subscription' && <SubscriptionPro/>}
                            </Col>
                        </Layout>
                    </Layout>
                </Row>
            </Content>
        </Layout>);
};
const AdditionalServices = () => {
    return (
        <Layout>
            <Content className="custom-portalContent-background">
                <Card className="ma-additional-services">
                    <div className={"ma-title"}>
                        Extra Services
                    </div>
                    <div className={"ma-sub-title"}>
                        Price based on requirement for premium users **
                    </div>
                    <div className="ma-service">
                        <div className="ma-service-header">
                            Allocated artist for bespoke playlists
                        </div>
                        <div className={"ma-service-content"}>
                            Premium users can select an artist of their choice from our platform to create customised
                            playlists
                            for
                            their business, helping you find the most suitable style and crafting artistically curated
                            playlists
                        </div>
                        <hr/>
                        <div className="ma-service-header">
                            Installation
                        </div>
                        <div className={"ma-service-content"}>
                            Prices are based on specific requirements, please contact us or ring us on 03455-481311 to get
                            a
                            quota
                            and your installation appointment booked
                        </div>
                        <hr/>
                        <div className="ma-service-header">
                            Advance replacement
                        </div>
                        <div className={"ma-service-content"}>
                            Complimentary during the warranty period. Please contact us
                            via <strong><a
                            href="mailto:support@vieunite.com"
                            style={{color: 'black', textDecoration: 'underline'}}>email</a></strong> or phone us on
                            03455-481311
                            for
                            more information
                        </div>
                        <hr/>
                        <div className="ma-service-header">
                            On site service
                        </div>
                        <div className={"ma-service-content"}>
                            Please contact us via <strong><a
                            href="mailto:support@vieunite.com"
                            style={{color: 'black', textDecoration: 'underline'}}>email</a></strong> or phone us
                            on 03455-481311 for more
                            information
                        </div>
                        <hr/>
                        <div className="ma-service-header">
                            Extension of warranty after 3 years
                        </div>
                        <div className={"ma-service-content"}>
                            £60.00 per year. Please contact us via <strong><a
                            href="mailto:support@vieunite.com"
                            style={{color: 'black', textDecoration: 'underline'}}>email</a></strong> or phone us on
                            03455-481311 for more
                            information
                        </div>
                    </div>
                </Card>
                <div className="ma-contact-section">
                    <div className="ma-CallText">Call us on 03455-481311</div>
                    <p></p>
                    <Button className="ma-EmailButton"
                            onClick={() => window.location = 'mailto:info@vieunite.com?subject=Mail from Our Website'}>Email
                        us
                    </Button>
                </div>
            </Content>
        </Layout>);
};

const SubscriptionPro = () => {
    const features = [
        {
            key: '1',
            feature: 'Number of Textura canvases',
            info: 'Number of Textura Pro digital displays where free and paid content, including GenAI contents are displayed.',
            standard: 'Up to 2',
            advanced: 'Up to 10',
            premium: 'Unlimited',
        },
        {
            key: '2',
            feature: 'Capacity to display your own media',
            info: 'Amount of cloud storage space available for own media, depending on subscribed plan. Full HD (1080p) images and videos are supported.',
            standard: '500MB',
            advanced: '4GB',
            premium: 'Unlimited',
        },
        {
            key: '3',
            feature: 'Access to Classic Creative Commons artwork(CC)',
            info: 'Access to free artworks Cost of artwork, under the Creative Commons license.',
            standard: <TickCircle />,
            advanced: <TickCircle />,
            premium:  <TickCircle />,
        },
        {
            key: '4',
            feature: 'Cost of artwork',
            info: 'Price of royalties for artworks not included under the Creative Commons license.',
            standard: 'Pay as priced',
            advanced: 'No cost',
            premium: 'No cost',
        },
        {
            key: '5',
            feature: 'Email & telephone support',
            info: 'Customer support services provided via email and telephone, depending on subscribed plan.',
            standard: <TickCircle />,
            advanced: 'Priority',
            premium: 'Dedicated Account Manager',
        },
        {
            key: '6',
            feature: 'Advanced artwork playlist(CC)',
            info: 'Curated artwork playlist delivered on a regular basis, under the Creative Commons license.',
            // showIcon: false,
            standard: <CrossCircle />,
            advanced: 'Unlimited',
            premium: 'Unlimited',
        },
        {
            key: '7',
            feature: 'Premium Playlist with rare collections',
            info: 'Premium-level playlist including paid artwork not included under the Creative Commons license.',
            standard: <CrossCircle />,
            advanced: <CrossCircle />,
            premium: 'Unlimited',
        },
        {
            key: '8',
            feature: 'Content curation',
            info: 'Arts curation by the Vieunite Pro content management system (CMS) team. This is done on a regular basis.',
            standard: <CrossCircle />,
            advanced: <CrossCircle />,
            premium: 'Unlimited',
        },
        {
            key: '9',
            feature: 'Content Management with Dedicated Account Manager',
            // showIcon: false,
            info: 'A dedicated account manager will be assigned to manage CMS for the subscriber.',
            standard: <CrossCircle />,
            advanced: <CrossCircle />,
            premium:  <TickCircle />,
        },
        {
            key: '10',
            feature: 'Allocated Services Manager',
            info: 'A dedicated customer services manager will be assigned to provide WhatsApp (WA) Business support under terms of the service level agreement (SLA).',
            standard: <CrossCircle />,
            advanced: <CrossCircle />,
            premium:  <TickCircle />,
        },
        {
            key: '11',
            feature: 'Allocated Designer',
            info: 'A dedicated design team member will be assigned, depending on subscribed plan.',
            standard: <CrossCircle />,
            advanced: <CrossCircle />,
            premium:  <TickCircle />,
        },
    ];
    const columns = [
        {
            title: '',
            dataIndex: 'feature',
            key: 'feature',
            render: (text, record) => (
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <span>{text}</span>
                    {record.showIcon !== false && (
                        <Tooltip title={record.info}>
                            <InfoButton/>
                        </Tooltip>
                    )}
                </div>
            ),
        },
        {
            title: <span className='SubTable-title'>Standard</span>,
            dataIndex: 'standard',
            key: 'standard',
            align: 'center',
            width: '20%',
        },
        {
            title: <span className='SubTable-title'>Advanced</span>,
            dataIndex: 'advanced',
            key: 'advanced',
            align: 'center',
            width: '20%',
        },
        {
            title: <span className='SubTable-title'>Premium</span>,
            dataIndex: 'premium',
            key: 'premium',
            align: 'center',
            width: '20%',
        },
    ];
    const navigate = useNavigate();
    const handleChangeUpdateClick = () => {
        navigate('/proportal/UpgradeSubscription');
    };
    const handleChangeUpdateClickPremium = () => {
        navigate('/proportal/UpgradeSubscriptionPremium');
    };
    const [isModalVisible, setIsModalVisible] = useState(false);
    // const showModal = () => {
    //     setIsModalVisible(true);
    // };
    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <Layout>
            <Content className="custom-portalContent-background">
                <div className="plan-titles-container">
                    {localStorage.getItem('subscription') === 'Standard' ?
                        <Row justify="space-around">
                            <Col className="Sub-Title-above1">
                                Your current plan
                            </Col>
                            <Col className="Sub-Title-above2">
                                Most popular
                            </Col>
                        </Row> : <></>}
                    {localStorage.getItem('subscription') === 'Advanced' ?
                        <Row justify="space-around">
                            <Col className="Sub-Title-above3">
                                Your current plan
                            </Col>
                            <Col className="Sub-Title-above4">
                                Upgrade to Premium
                            </Col>
                        </Row> : <></>}
                    {localStorage.getItem('subscription') === 'Premium' ?
                        <Row justify="space-around">
                            <Col className="Sub-Title-above5">
                                Your current plan
                            </Col>
                        </Row> : <></>}
                </div>
                <Card className="Subportal-Card">
                    <Table dataSource={features} columns={columns} pagination={false} className="custom-portal-table"/>
                    <div className="PortalButton-container">
                        {localStorage.getItem('subscription') === 'Standard' ?
                            <Button className="PortalSubUpgrade-Button" onClick={handleChangeUpdateClick}>
                                <div className="PortalSubCall-Button-text">
                                    Upgrade
                                </div>
                            </Button> : <></>}
                        {localStorage.getItem('subscription') === 'Standard' || localStorage.getItem('subscription') === 'Advanced' ?
                            // <Button className="PortalSubUpgrade-Button" onClick={showModal}>
                                <Button className="PortalSubUpgrade-Button" onClick={handleChangeUpdateClickPremium}>
                                <div className="PortalSubCall-Button-text">
                                    Upgrade
                                </div>
                            </Button> : <></>}
                        {/*<Modal title="Premium Subscription"*/}
                        {/*       visible={isModalVisible}*/}
                        {/*       onOk={handleOk}*/}
                        {/*       onCancel={handleCancel}*/}
                        {/*       className="custom-subscription-modal"*/}
                        {/*       footer={[*/}
                        {/*           <Button key="submit" type="primary" onClick={handleOk}*/}
                        {/*                   className="custom-modal-ok-button">*/}
                        {/*               OK*/}
                        {/*           </Button>,*/}
                        {/*       ]}*/}
                        {/*>*/}
                        {/*    <p className="modal-text-guidance" style={{ margin: '-20px 20px 20px' }}>Please contact our team for expert guidance on Premium*/}
                        {/*        level subscription.</p>*/}
                        {/*    <br/>*/}
                        {/*    <p className="modal-text-guidance">Call: <strong>01234 567 890</strong></p>*/}
                        {/*    <p className="modal-text-guidance">or email: <strong>help@vieuinite.com</strong></p>*/}
                        {/*</Modal>*/}
                    </div>

                </Card>
            </Content>
        </Layout>);
}

export default MyAccount;
